import { apiErrorMessageForUser } from './apiErrorMessage';

const responseStatus = (response) => {
  const status = Number(response?.status);
  return Number.isFinite(status) && status > 0 ? ` (${status})` : '';
};

const apiErrorMessage = (data) => {
  return apiErrorMessageForUser(data);
};

export const readJsonResponse = async (response, operation) => {
  let data;

  try {
    data = await response.json();
  } catch (error) {
    throw new Error(`${operation} returned an invalid response${responseStatus(response)}.`);
  }

  if (!response.ok) {
    throw new Error(
      apiErrorMessage(data) || `${operation} failed${responseStatus(response)}.`
    );
  }

  return data;
};

export const messageFromError = (error, fallback) => {
  const responseMessage = apiErrorMessageForUser(error?.response?.data);
  if (responseMessage) return responseMessage;

  return apiErrorMessageForUser(error?.message, fallback);
};
